import { EnumSolicitacaoCompraTipoFrete } from "../enum-types/enum-solicitacao-compra-tipo-frete";
import { SolicitacaoCompraItemCotacao } from "../managers/solicitacao-compra-item-cotacao";
import { Parcela } from "./parcela";
import { SolicitacaoCompra } from "./solicitacao-compra";

export class SolicitacaoCompraFornecedor {	
	public idGeral: string;
	public solicitacaoCompra?: SolicitacaoCompra;
	public vlFrete: number;
	public vlTotal: number;	
	public flStatus?: string;	
	public solicitacaoCompraItemCotacoes?: SolicitacaoCompraItemCotacao[] = [];
	public diasPrevEntrega: number;	
	public dtValidade: string;	
	public dtFaturamento: string;	
	public tpFrete: EnumSolicitacaoCompraTipoFrete;
	public prazoPagamento: string;	
	public size: number;
	public parcelas: Parcela[];
	public ordenacaoPortal: string;
}